import axios from 'axios'
import {
  Notify
} from 'vant';
import {
  Dialog
} from 'vant';
import store from '@/store'
import {
  getToken
} from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 401) {
      Dialog.alert({
        title: '你已经退出或者登录过期',
        message: '重新登录',
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      });
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Notify({
      type: 'danger',
      message: error.message
    });
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js